import React from "react";
import { Trans } from "react-i18next";
import i18n from "i18n";
import { fetchArchiveConfiguration } from "archive/hooks/useArchiveConfiguration";
import { Alert, Row, Col, Input } from "components/bootstrap";
import BootstrapModalForm from "components/bootstrap/BootstrapModalForm";
import { Spinner } from "components/common";
const NAMESPACE = "enterprise_archive";
const t = (key, options = {}) => i18n.t(key, { ns: NAMESPACE, ...options });
class ArchiveBackendDeletionForm extends React.Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.open = () => {
      this.setState({ showModal: true });
      fetchArchiveConfiguration().then((config) => this.setState({ config }));
    };
    this.close = () => {
      this.setState({ showModal: false });
    };
    this._onDelete = (e) => {
      const { backend, onDelete } = this.props;
      const { deleteArchives } = this.state;
      e.preventDefault();
      if (this._isDeletable()) {
        onDelete(backend, deleteArchives);
      }
    };
    this._onRemoveClick = (e) => {
      this.setState({ deleteArchives: e.target.checked });
    };
    this._isLoading = () => {
      const { config } = this.state;
      return !config;
    };
    this._isDeletable = () => {
      const { config: { backend_id: backendID } = {} } = this.state;
      const { backend } = this.props;
      return !this._isLoading() && backendID !== backend.id;
    };
    this._modalContent = () => {
      const { backend } = this.props;
      const { deleteArchives } = this.state;
      if (this._isLoading()) {
        return /* @__PURE__ */ React.createElement(Spinner, { text: t("archive_backend_deletion_form.loading_assigned_streams") });
      }
      if (!this._isDeletable()) {
        return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, /* @__PURE__ */ React.createElement(
          Trans,
          {
            i18n,
            ns: NAMESPACE,
            i18nKey: "archive_backend_deletion_form.in_use",
            values: { title: backend.title },
            components: { em: /* @__PURE__ */ React.createElement("em", null) }
          }
        )))));
      }
      return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
        Input,
        {
          type: "checkbox",
          id: "remove-data-checkbox",
          label: t("archive_backend_deletion_form.remove_archive_data_label"),
          help: /* @__PURE__ */ React.createElement("span", null, t("archive_backend_deletion_form.remove_archive_data_help")),
          checked: deleteArchives,
          onChange: this._onRemoveClick
        }
      )));
    };
    this.state = { config: void 0, deleteArchives: false, showModal: false };
  }
  render() {
    const { backend } = this.props;
    return /* @__PURE__ */ React.createElement(
      BootstrapModalForm,
      {
        show: this.state.showModal,
        onCancel: this.close,
        title: t("archive_backend_deletion_form.title", { title: backend.title }),
        "data-telemetry-title": "Delete backend",
        onSubmitForm: this._onDelete,
        submitButtonText: t("archive_backend_deletion_form.delete"),
        submitButtonDisabled: !this._isDeletable()
      },
      this._modalContent()
    );
  }
}
export default ArchiveBackendDeletionForm;
